import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

// Fixed over the chat sidebar panel: docked left under the header on desktop, a right sheet on mobile.
export const CHAT_SUGGESTIONS_LAYER_OUTER_CLASS = 'pointer-events-none fixed bottom-40 left-0 top-(--header-height) z-50 flex w-(--sidebar-width) min-w-0 items-end overflow-hidden group-data-[collapsible=offcanvas]:hidden max-md:left-auto max-md:right-0';
export const CHAT_SUGGESTIONS_CONTENT_INSET_CLASS = 'px-3';

// A suggestion row pads its icon 6px in, and the list pulls its rows 6px out, so the icons line
// up with the column's text wherever a list sits.
export const CHAT_SUGGESTION_LIST_CLASS = '-mx-1.5 min-w-0';
export const CHAT_SUGGESTION_ROW_LAYOUT_CLASS = 'flex h-8 w-full items-center gap-2 px-1.5 py-0';
const CHAT_SUGGESTIONS_SKELETON_TITLE_WIDTHS = ['w-3/4', 'w-2/3', 'w-1/3'] as const;
type ChatSuggestionsSkeletonProps = {
  className?: string;
};
export function ChatSuggestionsSkeleton(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full", CHAT_SUGGESTIONS_CONTENT_INSET_CLASS, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={CHAT_SUGGESTION_LIST_CLASS} data-testid="chat-suggestions-skeleton">{CHAT_SUGGESTIONS_SKELETON_TITLE_WIDTHS.map(_temp)}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className={t1}>{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(titleWidth) {
  return <div key={titleWidth} className={CHAT_SUGGESTION_ROW_LAYOUT_CLASS}><Skeleton className="size-3.5 shrink-0 rounded-sm" /><Skeleton className={cn("h-3", titleWidth)} /></div>;
}